export const DEFAULT_LOCALE = {
  page: 'Page #{page}',
  goto: 'Go to page #{page}',
  prevPage: 'Go to previous page',
  nextPage: 'Go to next page',
};

export type Locale = typeof DEFAULT_LOCALE;
